/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShapeTriangleUpIcon20Light = forwardRef('ShapeTriangleUpIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.32 2.927a2 2 0 0 1 3.36 0l6.464 10c.86 1.332-.095 3.087-1.68 3.087H3.536c-1.585 0-2.54-1.755-1.68-3.086l6.464-10Zm2.52.543a1 1 0 0 0-1.68 0l-6.464 10a1 1 0 0 0 .84 1.543h12.928a1 1 0 0 0 .84-1.542l-6.464-10Z" })));
});
